import { useScrollReveal } from '@/hooks/useScrollReveal';

const rankings = [
  { rank: 1, title: '深渊之触', category: '奇幻冒险', heat: '98.7 万热度', status: '连载中', change: 'up' },
  { rank: 2, title: '异种学院', category: '校园奇幻', heat: '92.3 万热度', status: '连载中', change: 'same' },
  { rank: 3, title: '触手纪元', category: '科幻异种', heat: '88.5 万热度', status: '已完结', change: 'down' },
  { rank: 4, title: '暗影使徒', category: '都市传说', heat: '76.1 万热度', status: '连载中', change: 'up' },
  { rank: 5, title: '触手猎人', category: '热血战斗', heat: '71.4 万热度', status: '已完结', change: 'same' },
  { rank: 6, title: '星海迷踪', category: '太空歌剧', heat: '65.8 万热度', status: '连载中', change: 'up' },
  { rank: 7, title: '星域触手姬', category: '科幻新作', heat: '48.2 万热度', status: '连载中', change: 'new' },
];

function getChangeInfo(change: string) {
  if (change === 'up') return { icon: 'ri-arrow-up-line', color: 'text-accent-500' };
  if (change === 'down') return { icon: 'ri-arrow-down-line', color: 'text-primary-500' };
  if (change === 'new') return { icon: 'ri-sparkling-line', color: 'text-amber-500' };
  return { icon: 'ri-subtract-line', color: 'text-foreground-500' };
}

export default function RankingSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="ranking" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/60 border border-primary-200/50 mb-4">
            <i className="ri-trophy-line text-primary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">实时数据 · 每日更新</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热力榜单
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            触手漫画实时热度排行，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
          {rankings.map((item, idx) => {
            const changeInfo = getChangeInfo(item.change);
            return (
              <RankingItem key={idx} item={item} changeInfo={changeInfo} idx={idx} isLast={idx === rankings.length - 1} />
            );
          })}
        </div>
      </div>
    </section>
  );
}

function RankingItem({
  item,
  changeInfo,
  idx,
  isLast,
}: {
  item: typeof rankings[0];
  changeInfo: { icon: string; color: string };
  idx: number;
  isLast: boolean;
}) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <a
      ref={ref}
      href="#cards"
      className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/30 transition-colors cursor-pointer ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      } ${!isLast ? 'border-b border-background-200/40' : ''}`}
    >
      <div
        className={`w-8 h-8 flex items-center justify-center rounded-full font-heading font-bold text-sm flex-shrink-0 ${
          item.rank === 1
            ? 'bg-primary-500 text-white'
            : item.rank === 2
            ? 'bg-primary-400 text-white'
            : item.rank === 3
            ? 'bg-primary-300 text-primary-800'
            : 'bg-background-200 text-foreground-600'
        }`}
      >
        {item.rank}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</span>
          <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{item.status}</span>
        </div>
      </div>
      <div className="text-xs text-foreground-600 font-medium whitespace-nowrap">{item.heat}</div>
      <div className={`w-5 h-5 flex items-center justify-center ${changeInfo.color}`}>
        <i className={`${changeInfo.icon} text-xs`}></i>
      </div>
    </a>
  );
}